/*
** 
** 应用全局参数配置 | Apply global parameter configuration
** 
**/


const param = {

    url_prefix: 'http://srm.liyuanheng.com/api/', 
    //[ 请求地址头 | Request address header]

    resource: 'http://husan.husan.com.cn/lyh/img/', 
    //[ 静态资源 | resource] http://husan.husan.com.cn/xxxx/

    //全局图标规范化
    //<i class="v-icon-" :style="'background-image:url(' + this.$config.resource + 'xxxxxx.png)'"></i>

    //全局图片规范化
    //<img :src="this.$config.resource + 'xxxxxx.png'" alt="" />

}

export default param;


// WEBPACK FOOTER //
// ./src/utils/config.js